import axios from "axios";
import { getToken } from "./auth";

const preferenceApi = axios.create({
  baseURL: `${process.env.REACT_APP_API_BASE_URL}/api/preferences`,
});

preferenceApi.interceptors.request.use((config) => {
  const token = getToken();
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export default preferenceApi;
